import { z } from 'zod'

export const SessionCaptureCoverageSchema = z.object({
  status: z.enum(['complete', 'partial']),
  stop_reason: z.enum(['deadline', 'source_error']).nullable(),
  events_total: z.number().int().nonnegative(),
  events_with_checkpoints: z.number().int().nonnegative(),
  events_in_journey: z.number().int().nonnegative(),
  snapshots_generated: z.number().int().nonnegative(),
  snapshots_reused: z.number().int().nonnegative(),
  screenshots_saved: z.number().int().nonnegative(),
  source_start_ms: z.number(),
  source_end_ms: z.number(),
  captured_through_ms: z.number(),
  capture_elapsed_ms: z.number().nonnegative(),
})
export type SessionCaptureCoverage = z.infer<typeof SessionCaptureCoverageSchema>

export function captureCoverageNote(c: SessionCaptureCoverage): string {
  return `${c.status === 'partial' ? 'Partial capture' : 'Complete capture'}: ${c.events_with_checkpoints} of ${c.events_total} events have checkpoints; ${c.events_in_journey} journey actions. Original-session coverage ends at ${(c.captured_through_ms / 1000).toFixed(1)}s of ${(c.source_end_ms / 1000).toFixed(1)}s. ${c.stop_reason === 'deadline' ? 'Stopped to finalize before the task deadline.' : c.stop_reason === 'source_error' ? 'Stopped because the session source could not provide further evidence.' : ''}`.trim()
}
